import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { clearState } from '../../shared/store/shared.actions';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
    constructor(private store: Store) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                const errorMessage =
                    error?.error?.message ?? error?.message ?? '';

                if (
                    typeof errorMessage === 'string' &&
                    (errorMessage.includes(
                        'cannot find partner config for partnerId/applicationId'
                    ) ||
                        errorMessage.includes('Search session has expired'))
                ) {
                    this.handleSessionExpired();
                }

                return throwError(error);
            })
        );
    }

    private handleSessionExpired() {
        this.store.dispatch(clearState());
    }
}
